
export const AdminJobCode = {
  A001: "1001", // 市场经理
  A002: "1002", // 市场助理
  A003: "1003", // 审核
  A004: "1004", // 售后客服
  A005: "1005", // 产研
  A006: "1006", // 运营
  A007: "1007", // 法务
  A008: "1008", // 财务
  A999: "1999", // 内部其他岗位
  B999: "2999", // 外部其他岗位
};
